function importGuestsDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/import-guests/import-guests-dialog.html?$$REVISION$$'
  }
}

export { importGuestsDialogDirective }
